import colors from './colors'
import typography from './typography'
import breakpoints from './breakpoints'
import colorScheme from './colorScheme'
import palette from './palette'
export default {
  // gridCustomConf: {},
  colors,
  colorScheme,
  typography,
  breakpoints,
  palette,
  shadows: {
    type1: '0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06)',
    type2: '0px 4px 8px -2px rgba(16, 24, 40, 0.1), 0px 2px 4px -2px rgba(16, 24, 40, 0.06)',
    type3: '0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03)',
    type4: '0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)',
  },
  timing: {
    slow: '0.6s ease-in-out',
    normal: '0.3s ease-in-out',
    fast: '0.2s ease-in-out',
  },
  layers: {
    header: 10,
    menu: 20,
    cookieBanner: 10,
    stickyCta: 10,
  },
}
